import styles from './EncounterTemplateNoteForm.module.scss';
import * as Yup from 'yup';
import { Form } from '@webinex/antik';
import type { Descendant } from 'slate';
import { NoteTemplateRichTextAreaComponent } from '@app/medical-record/widgets/EncounterTemplates.Common';
import classNames from 'classnames';
import { slateContentToString } from '@app/ui';
import { isEmpty } from 'lodash';

export interface EncounterTemplateFormProps {
  value: EncounterTemplateNoteFormValue;
  readonly?: boolean;
  onSubmit: (value: EncounterTemplateNoteFormValue) => void;
  className?: string;
  autoFocusNote?: boolean;
}

const ENCOUNTER_NOTE_SCHEMA = Yup.object({
  name: Yup.string().nullable().defined().required(),
  note: Yup.mixed<Descendant[]>().nullable().defined().required(),
});

export type EncounterTemplateNoteFormValue = Yup.InferType<typeof ENCOUNTER_NOTE_SCHEMA>;

export function EncounterTemplateNoteForm(props: EncounterTemplateFormProps) {
  const { value, onSubmit, readonly, className, autoFocusNote } = props;
  const autoFocus = !readonly && isEmpty(slateContentToString(value.note)) && autoFocusNote;

  return (
    <Form<EncounterTemplateNoteFormValue>
      uid="encounter-template-note-form"
      type="formik"
      initialValues={value}
      validationSchema={ENCOUNTER_NOTE_SCHEMA}
      onSubmit={onSubmit}
      ns="encounterTemplates.details"
      rootClassName="flex flex-col h-full"
      enableReinitialize
    >
      <Form.Item name="name" required className="flex-none">
        <Form.Input />
      </Form.Item>
      <Form.Item name="note" required className={styles.form}>
        <Form.RichTextArea
          className={classNames(className, styles.note)}
          readonly={readonly}
          Component={NoteTemplateRichTextAreaComponent(autoFocus)}
          shownCommandButton
        />
      </Form.Item>
    </Form>
  );
}
